import { ArrowRight, Download, TriangleAlert } from "lucide-react";
import type { MachineUpdateView } from "@racler/protocol";
import { homeUpdateSummary, updateTexts } from "../lib/desktopUpdates.ts";
import { navigate } from "../lib/router.ts";
import { useMachineUpdates } from "../lib/useMachineUpdates.ts";

/** Compact home page hint that Desktop updates are available. Never installs anything; it only links to Machines. */
export function UpdatesNotice() {
  const { views } = useMachineUpdates();
  return <UpdatesNoticeView views={views} />;
}

export function UpdatesNoticeView({ views }: { views: ReadonlyMap<string, MachineUpdateView> | null }) {
  const summary = views ? homeUpdateSummary(views.values()) : null;
  if (!summary) return null;
  const Icon = summary.tone === "required" ? TriangleAlert : Download;
  return (
    <section
      className={`updates-notice ${summary.tone}`}
      data-testid="home-updates-notice"
      aria-label="Desktop updates"
    >
      <Icon size={15} aria-hidden />
      <span className="updates-notice-text">{summary.text}</span>
      <button type="button" className="link-btn" onClick={() => navigate("/settings/machines")}>
        {updateTexts.homeReview} <ArrowRight size={13} aria-hidden />
      </button>
    </section>
  );
}
